export const CONTRACT_STATUS_TITLES = {
    signed_by_instructor: 'Podepsáno instruktorem',
    signed: 'Podepsáno oběma stranami',
    invalidated: 'Zneplatněno',
};
